<template>
    <div>
        <el-header height="89px" v-show="isHeader">
            <el-row :gutter="0" :class="{headerBox: scrollTop > 0}" style="height: 89px;">
                <el-col :span="11" align="middle" class="header-item">
                    <img src="@/assets/images/logo1.png" v-show="scrollTop == 0" class="header-logo">
                    <img src="@/assets/images/logo2.png" v-show="scrollTop > 0" class="header-logo">
                </el-col>
                <el-col :span="13" align="left">
                    <el-menu
                        :default-active="activeIndex"
                        @select="handleSelect"
                        :active-text-color="activeTextColor"
                        class="el-menu-demo"
                        mode="horizontal"
                        :text-color="textColor">
                        <el-menu-item v-for="(item, index) in menuList" :key="index" :index="item.code">{{item.name}}</el-menu-item>
                    </el-menu>
                    <el-button style="position: absolute;top: 24px;right: 20px;" @click="routerLinkEvent">平台登录</el-button>
                </el-col>
            </el-row>
        </el-header>
    </div>
</template>

<script>
export default {
    name: 'Header',
    data () {
        return {
            isHeader: true,
            activeIndex: 'Home',
            activeTextColor: '#fff',
            textColor: '#fff',
            menuList: [
                {
                    code: 'Home',
                    name: '首页'
                },
                {
                    code: 'News',
                    name: '新闻动态'
                },
                {
                    code: 'Consult',
                    name: '咨询投诉'
                },
                {
                    code: 'Appraise',
                    name: '评价公示'
                },
                {
                    code: 'About',
                    name: '关于我们'
                }
            ],
            scrollTop: 0
        }
    },
    created () {
        if (this.$route.name === 'Project') {
            this.isHeader = false
        }
        // let that = this
        // if (this.$route.name) {
        //     this.menuList.forEach(function (item) {
        //         if (item.code === that.$route.name) {
        //             that.activeIndex = item.code
        //         }
        //     })
        // }
        // if (this.$route.name !== 'Home') {
        //     this.$emit('headerChange', true)
        // } else {
        //     this.$emit('headerChange', false)
        // }
        window.addEventListener('scroll', this.handleScroll, true)
    },
    updated () {
        let that = this
        if (this.$route.name) {
            this.menuList.forEach(function (item) {
                if (item.code === that.$route.name) {
                    that.activeIndex = item.code
                }
            })
        }
        if (this.$route.name !== 'Home') {
            this.$emit('headerChange', true)
        } else {
            this.$emit('headerChange', false)
        }
    },
    watch: {
        $route (to, from) {
            let that = this
            if (to.name) {
                this.menuList.forEach(function (item) {
                    if (item.code === that.$route.name) {
                        that.activeIndex = item.code
                    }
                })
            }
        }
    },
    methods: {
        // 保存滚动值，这是兼容的写法
        handleScroll () {
            this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if (this.scrollTop > 0) {
                this.activeTextColor = '#000'
                this.textColor = '#000'
            } else {
                this.activeTextColor = '#fff'
                this.textColor = '#fff'
            }
        },
        handleScrollEvent (scrollTop) {
            if (scrollTop > 0) {
                this.activeTextColor = '#000'
                this.textColor = '#000'
            } else {
                this.activeTextColor = '#fff'
                this.textColor = '#fff'
            }
        },
        // 滚动条回到顶部
        backTop () {
            if (this.scrollTop > 10) {
                document.documentElement.scrollTop = 0
            }
        },
        handleSelect (key, keyPath) {
            this.activeIndex = key
            if (key === 'Home') {
                this.$emit('headerChange', false)
                this.$router.push('/')
            } else {
                this.$emit('headerChange', true)
                this.$router.push({name: key})
            }
        },
        routerLinkEvent () {
            window.location.href = 'http://124.70.68.68:33380'
        }
    },
    destroyed () {
        // 离开该页面需要移除这个监听的事件，不然会报错
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style scoped>
    .el-header {
        padding: 0;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 99;
        background-color:rgb(39,122,191, 0);
        border-bottom: 1px solid rgba(255,255,255,.3);
    }
    .headerBox{
        transition: height,background .3s ease-out;
        box-shadow: 0 0 5px 2px #b5b5b5;
        background: #ffffff;
    }
    .header-item{
    }
    .header-logo{
        height: 38px;
        width: 192px;
        display: block;
        margin-top: 26px;
    }
    .el-menu-demo{
        display: inline-block;
        background-color:rgb(39,122,191, 0);
    }
    .el-menu--horizontal>.el-menu-item{
        height: 89px;
        line-height: 89px;
        font-size: 18px;
        font-weight: 100;
    }
    .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
        background-color: rgb(255,255,255, 0.2);
    }
    .headerBox .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .headerBox .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .headerBox .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
        background-color: rgb(0,0,0, 0.2);
    }
    .is-active{
        /*border-bottom: none!important;
        font-weight: 500!important;*/
    }
    .el-menu.el-menu--horizontal {
         border-bottom: none;
    }
   /* .el-menu-demo{
        height: 50px;
    }
    .el-menu-item{
        height: 50px;
        line-height: 50px;
    }*/
</style>



// WEBPACK FOOTER //
// src/components/layouts/Header.vue